import AxiosBusiness from '@/services/api/business/axios_business'

export default {
  // Status endpoints
  createStatus: (data) => {
    return AxiosBusiness.post('status', data)
  },

  updateStatus: (statusId, data) => {
    return AxiosBusiness.put(`status/${statusId}`, data)
  },

  getStatus: (statusId) => {
    return AxiosBusiness.get(`status/${statusId}`)
  },

  getAllStatusesByCustomer: (customerId, params) => {
    return AxiosBusiness.get(`status/customer/${customerId}`, { params })
  },

  getAllStatusesByFormat: (formatId, params) => {
    return AxiosBusiness.get(`status/format/${formatId}`, { params })
  },

  deleteStatus: (statusId) => {
    return AxiosBusiness.delete(`status/${statusId}`)
  }
}
